import React from 'react';
import Modal, { Footer } from '@/components/common/Modal';
import Text from '@/components/ui/Text';
import I18n from '@/modules/i18n';
import { correlationLabel, ModelCorrelation } from '../types';

// A master-checkbox selection can run to hundreds of rows; frame 3A's body is one short sentence.
const MAX_LISTED_STANDARDS = 5;

interface BulkRemoveModalProps {
  correlations: ModelCorrelation[];
  isOpen: boolean;
  isRemoving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const BulkRemoveModal = ({
  correlations, isOpen, isRemoving, onCancel, onConfirm,
}: BulkRemoveModalProps) => {
  const listed = correlations.slice(0, MAX_LISTED_STANDARDS);
  const unlisted = correlations.length - listed.length;

  return (
    <Modal
      closeModal={onCancel}
      footer={(
        <Footer
          primaryButtonCallback={onConfirm}
          primaryButtonClassName="btn btn--red"
          primaryButtonSubmit={false}
          primaryButtonText={I18n.t('remove')}
          secondaryButtonCallback={onCancel}
          secondaryButtonText={I18n.t('cancel')}
          submitting={isRemoving}
          wrapperClassName="tw-pr-4 tw-pb-4"
        />
      )}
      headerText={I18n.t('remove_n_correlations', { count: correlations.length })}
      isOpen={isOpen}
    >
      <Text size="sm">
        {I18n.t('bulk_remove_body_prefix')}
        {' '}
        <strong>{listed.map(correlationLabel).join(', ')}</strong>
        {unlisted > 0 && ` ${I18n.t('and_n_more', { count: unlisted })}`}
        {' '}
        {I18n.t('bulk_remove_body_suffix')}
      </Text>
    </Modal>
  );
};

export default BulkRemoveModal;
